export default __webpack_public_path__ + "static/media/instagram.46d2a9e7.svg";